import type { UserEmail } from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1/email_address';

export const getUnverifiedNonPrimaryEmail = (emails: UserEmail[]) => {
  return emails.find((email) => !email.isVerified && !email.isPrimary);
};
